export default __webpack_public_path__ + "static/shayne_w-8b20378096717e60e771360d4a53a597.png";